/* Links inside a sentence keep a faint line at rest so they read as links (Jim 2026-09-27: "句子里的链接平时加一条淡线").
   A link counts as "in a sentence" when its paragraph has other words beside it; a link that stands alone in
   its line (an email, a phone number, "View all") stays like the top menu: no line until hover. */
(function () {
  function mark(root) {
    root.querySelectorAll('main p a, footer p a, .rte a, .gh-product__tradeline a, .gh-prose__note a').forEach(function (a) {
      if (a.classList.contains('gh-btn') || a.querySelector('img')) return;
      // breadcrumbs and label rows (All / Bed, Collection Azara) are not sentences
      if (a.closest('.gh-product__crumb, .gh-product__series, .gh-room__crumb, nav')) return;
      var box = a.closest('p, li, .gh-product__tradeline, .gh-prose__note') || a.parentElement;
      var rest = (box.textContent || '').replace(a.textContent || '', '').replace(/[\s .,;:!?()\-–—\/|·•]+/g, '');
      if (rest.length > 2) a.classList.add('gh-inline-link');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mark(document); });
  else mark(document);
})();
